import { IBaseDtoType } from './common.type'
import { IAccountBaseWithId } from './account.type'
import { IProfileUserBaseWithId } from './user.type'

export enum ETransactionType {
  Arweave = 'arweave',
  Scan = 'scan',
  ConsumerScan = 'consumer_scan',
  AccountToken = 'account_token',
  ProductToken = 'product_token',
}

export interface ITransactionLogBase {
  from: string | null
  to: string | null
  hash: string
  type: ETransactionType
  data: string | null
  explorer_url: string | null
}

export interface ITransactionLogBaseWithId extends ITransactionLogBase, IBaseDtoType {}

export interface ITransactionLogDto extends ITransactionLogBaseWithId {
  user: IProfileUserBaseWithId | null
  account: IAccountBaseWithId | null
}

export interface ITransactionLogsRespDto {
  count: number
  data: ITransactionLogDto[]
}
